import { Component, HostListener, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterOutlet } from '@angular/router';
import { MatIconRegistry } from '@angular/material/icon';

import { FirebaseAuthService } from './core/firebase/firebase-auth.service';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from './core/i18n.service';

import {
  CredentialsRequestMessage,
  GetInitialStateMessage,
  CredentialRequestSimpleMessage,
} from '../../../commondata/messages/messages-dto';
import { AuthenticationService } from './core/authentication/authentication.service';

import * as itIT from '../translations/it-IT.json';
import * as enGB from '../translations/en-GB.json';

import { environment } from '../../../commondata/environments/environment';
import { ModuleMessageService } from './core/module-message.service';
import { ModuleStateService } from './module-state.service';
import { Subscription } from 'rxjs';
import { ThemeManagerService } from './theme-manager.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, RouterModule, LoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'admin';

  private firebaseAuthService = inject(FirebaseAuthService);
  private moduleMessageService = inject(ModuleMessageService);
  private moduleStateService = inject(ModuleStateService);
  changedUserSubscrition: Subscription | undefined;

  @HostListener('window:message', ['$event'])
  onMessage(event: any) {
    this.moduleMessageService.handleMessage(event);
  }

  //  private locationHistoryService = inject(UrlService);
  private themeManagerService = inject(ThemeManagerService);
  //private router = inject(Router);
  private i18nService = inject(I18nService);
  private translateService = inject(TranslateService);
  // private firebaseAuthService = inject(FirebaseAuthService);
  private authenticationService = inject(AuthenticationService);
  private matIconReg = inject(MatIconRegistry);
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private domSanitizer: DomSanitizer,
  ) {
    console.log('AppComponent constructor');
    this.changedUserSubscrition?.unsubscribe();
    if (this.authenticationService.isAuthenticated()) {
      this.changedUserSubscrition = this.firebaseAuthService.changedUser.subscribe((user: any) => {
        // if (user !== null) {
        this.authenticationService.reloadCredentials();
        // this.router.navigate(['']);
        // }
        console.log('#########changedUser: ', user);
        // if (user != null) {
        this.isChangedUser = true;
        // }
        this.askCredentials();
      });
    }
  }

  private isChangedUser = false;
  private isParamsChanged = false;
  private credentialAsked = false;
  private paramsSubscription: Subscription | undefined;

  ngOnInit(): void {
    // const renewingSub = localStorage.getItem('renewingSub');
    // if (renewingSub) {
    //   this.moduleMessageService.sendMessage(new CredentialRequestSimpleMessage(this.moduleStateService.guid));
    // }
    this.authenticationService.reloadCredentials();
    this.isChangedUser = !this.authenticationService.isAuthenticated();
    this.isParamsChanged = false;
    this.credentialAsked = false;
    // Setup translations
    const translations: any = { 'it-IT': itIT, 'en-GB': enGB };
    this.i18nService.init(
      environment.defaultLanguage,
      environment.supportedLanguages,
      translations,
    );
    environment.supportedLanguages.forEach((element) => {
      this.translateService.getTranslation(element);
    });

    // Set default icon stile
    this.matIconReg.setDefaultFontSetClass('material-symbols-rounded');
    this.matIconReg.addSvgIcon(
      'claire',
      this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/claire-icon.svg'),
    );

    // Viene usata la skip perche' il primo subscribe viene lanciato al caricamento del componente con valori vuoti
    // this.route.queryParamMap.pipe(skip(1)).subscribe(
    if (this.paramsSubscription) {
      this.paramsSubscription.unsubscribe();
    }
    this.paramsSubscription = this.route.queryParams.subscribe((params) => {
      const path = params['path'] ?? '';
      if (path) {
        this.moduleStateService.path = path;
      }
      const guid = params['guid'] ?? '';
      if (guid) {
        this.moduleStateService.guid = guid;
        this.isParamsChanged = true;
      }
      console.log('#########GUID: ', guid);
      this.askCredentials();
    });
    // setTimeout(() => {
    //   if (!this.credentialAsked) {
    //     this.isChangedUser = true;
    //     this.isParamsChanged = true;
    //     this.askCredentials();
    //   }
    // }, 5000)
    // Initialize Matomo tracker GDPR-compliant
    // Verifichiamo di essere nel browser (e non in Server Side Rendering SSR)
    if (typeof window !== 'undefined') {
      const _paq = ((window as any)._paq = (window as any)._paq || []);
      // Applichiamo i comandi nativi sfruttando il motore asincrono di Matomo
      // _paq.push(['anonymizeIp']);
      _paq.push(['enableHeartBeatTimer', 15]);
      // _paq.push(['discardHashInUrl', true]);
      _paq.push(['disableCookies']);
      _paq.push(['disableBrowserFeatureDetection']);
      _paq.push(['disableCampaignParameters']);
      _paq.push(['setExcludedQueryParams', [
        "account", "accountnum", "address", "address1", "address2", "address3",
        "addressline1", "addressline2", "adres", "adresse", "adresse1", "adresse2",
        "adresse3", "adresse_email", "adresseemail", "adressepostale", "age", "alter",
        "auth", "authpw", "bic", "billingaddress", "billingaddress1", "billingaddress2",
        "calle", "cardnumber", "carte", "cartebancaire", "carteidentite", "cb", "cc",
        "ccc", "cccsc", "cccvc", "cccvv", "ccexpiry", "ccexpmonth", "ccexpyear", "ccname",
        "ccnumber", "cctype", "cell", "cellphone", "city", "civilite", "civilité", "cle",
        "clientid", "clientsecret", "clé", "codepostal", "company", "consumerkey",
        "consumersecret", "contrasenya", "contraseña", "courriel", "cp", "creditcard",
        "creditcardnumber", "cvc", "cvv", "datedenaissance", "dateexpiration", "datenaissance",
        "dateofbirth", "debitcard", "departement", "dirección", "dob", "domain",
        "département", "ebost", "email", "emailaddress", "emailadresse", "entreprise",
        "epos", "epost", "eposta", "exp", "expiration", "familyname", "firma", "firstname",
        "formlogin", "fullname", "gender", "genre", "geschlecht", "gst", "gstnumber",
        "handynummer", "hasło", "heslo", "iban", "ibanaccountnum", "ibanaccountnumber",
        "id", "identifiant", "identifier", "identitenationale", "indirizzo", "kartakredytowa",
        "kennwort", "keyconsumerkey", "keyconsumersecret", "konto", "kontonr", "kontonummer",
        "kredietkaart", "kreditkarte", "kreditkort", "lastname", "login", "mail", "mdp",
        "mobiili", "mobile", "mobilne", "mot_de_passe", "motdepasse", "nachname", "name",
        "nationalite", "nickname", "nom", "nomcomplet", "nomdefamille", "nomfamille",
        "nss", "numero_fiscal", "numerocarte", "numerocarteidentite", "numerocompte",
        "numerodecarte", "numerofiscal", "numeroidentite", "numeromobile", "numeropasseport",
        "numerosecuritesociale", "numerotelephone", "numerotva", "numfiscal", "numsecu",
        "numtva", "osoite", "parole", "pass", "passeport", "passord", "password",
        "passwort", "pasword", "paswort", "paword", "pays", "phone", "pin", "plz",
        "portable", "postalcode", "postcode", "postleitzahl", "prenom", "privatekey",
        "prénom", "publickey", "pw", "pwd", "pword", "pwrd", "questionsecrete", "region",
        "reponsesecrete", "rib", "rue", "secret", "secretclé", "secretq", "secretquestion",
        "securitesociale", "sexe", "shippingaddress", "shippingaddress1", "shippingaddress2",
        "signature", "siren", "siret", "socialsec", "socialsecuritynumber", "societe",
        "socsec", "sokak", "ssn", "steuernummer", "strasse", "street", "surname", "swift",
        "tax", "taxnumber", "tel", "telefon", "telefonnr", "telefonnummer", "telefono",
        "telephone", "titre", "token", "token_auth", "tokenauth", "tva", "téléphone",
        "ulica", "user", "username", "utilisateur", "vat", "vatnumber", "via", "ville",
        "voie", "vorname", "wachtwoord", "wagwoord", "webhooksecret", "website", "zip",
        "zipcode"
      ]]);
      // 2. FORZIAMO il tracciamento della pagina corrente e abilitiamo l'ascolto dei click sui link
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
    }
  }

  private askCredentials() {
    if (!this.credentialAsked && this.isChangedUser && this.isParamsChanged) {
      //if (this.moduleStateService.guid && !this.credentialAsked) {
      // Inizializza messaggi con la shell
      this.moduleMessageService.initialize(this.moduleStateService.guid, 'admin-page', true);
      this.moduleMessageService.sendMessage(
        new GetInitialStateMessage(this.moduleStateService.guid),
      );
      // Recupera le credenziali dalla shell
      // if (this.authenticationService.credentials) {
      const msg = new CredentialsRequestMessage(this.moduleStateService.guid, {});
      console.log('#########Richiedi le credenziali');
      this.credentialAsked = true;
      this.moduleMessageService.sendMessage(msg);
      // } else {
      //   let url = '';
      //   if (this.moduleStateService.path !== '') {
      //     url = this.moduleStateService.path.replace("'", "");
      //     this.router.navigate([url], { replaceUrl: true });
      //   }
      // }
    }
  }
}
